const d = {
  "cdr-list": "cdr-list_15-5-1",
  "cdr-list--compact": "cdr-list--compact_15-5-1",
  "cdr-list--ordered": "cdr-list--ordered_15-5-1",
  "cdr-list--unordered": "cdr-list--unordered_15-5-1",
  "cdr-list--inline": "cdr-list--inline_15-5-1"
};
export {
  d as default
};
